export function prop<Type, Key extends keyof Type>(obj: Type, key: Key) {
  return obj[key];
}
